export default __webpack_public_path__ + "static/media/MATHEMATICS_NUMBERS_AND_OPERATIONS.cb39b258.svg";